// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"a2076657","254":"d1aa3e54","364":"c9927798","452":"d374a313"}[chunkId] + ".css";
};